export interface NamedPlaintextKey {
  name: string;
  key: string;
}

// withSharedDisplayName assigns one display name to every plaintext key in a
// multi-key submission. The timestamp is injectable so the fallback behavior
// can be verified deterministically without exposing plaintext values.
export function withSharedDisplayName(
  keys: string[],
  displayName: string,
  supplier: string,
  timestamp = Date.now(),
): NamedPlaintextKey[] {
  const sharedName = displayName.trim() || `${supplier}-${timestamp}`;
  return keys.map((key) => ({ name: sharedName, key }));
}
